class BESSAppProjectSection extends BESSAppBase {
    constructor() {
        super();
        this.present = $('.app-project-page').length > 0;
        if (!this.present) return;
        this.projectId = $('.app-project-id').attr('data-project-id');
        this.engineVersion = $('.app-project-id').attr('data-engine-version');
        this.components = {
            sidebar: new BESSAppProjectSidebar(),
            mandatoryCreditsSummary: new BESSAppProjectMandatoryCreditsSummary(),
            buildingCompositionChart: new BESSAppProjectBuildingCompositionChart(),
            buildingClassCompositionChart: new BESSAppProjectBuildingClassCompositionChart(),
            accessibleToCouncil: new BESSAppAccessibleToCouncil(),
            categoryNotes: new BESSAppProjectCategoryNotes(),
            bookmarks: new BESSAppProjectBookmarks(),
            report: new BESSAppProjectReport(),
            publish: new BESSAppProjectPublishReport(),
            versions: new BESSAppProjectVersions(),
            docsEvidence: new BESSAppProjectDocsEvidence(),
        }
        this.evaluationMonitor = new BESSAppProjectEvaluationMonitorService();

        this.docsNav = $('.app-nav-app-tool-notes');
        this.docsNav.attr('href', '/app/tool-notes/BESS' + this.engineVersion);
    }

    start() {
        if (!this.present) return;

        this.evaluationMonitor.start();

        this.components.buildingCompositionChart.start();
        this.components.buildingClassCompositionChart.start();
        this.components.bookmarks.start();
        this.components.report.start();
        this.components.publish.start();

        if ($('#appProjectInitialising').length > 0) {
            let message = '<p>Please wait or <a href="/app/project/' + this.projectId + '">go back to project details</a></p>';
            this.showDoingWork(
                'Setting up your project.',
                message
            );
            this.subscribeToEvents(BESSAppEvaluatedEvent.name, function () {
                window.location.reload();
            });
        } else if ($('#appShowUpgradeMessage').length > 0) {
            bootbox.confirm({
                message: 'This project was created using an earlier version of BESS. Would you like to upgrade it to the latest version of BESS? ' +
                    'This will create a copy of this project. Note that you can upgrade old projects at any time from the sidebar.',
                buttons: {
                    confirm: {
                        label: 'Yes'
                    },
                    cancel: {
                        label: 'No thanks'
                    }
                },
                callback: function (confirmed) {
                    if (confirmed) {
                        let loc = window.location;
                        window.location = loc.protocol + '//' + loc.host + loc.pathname + '?upgrade=true';
                    }
                }
            });
        } else if ($('#appShowUpgradedMessageRequiresBuildings').length > 0) {
            bootbox.alert(
                'This upgraded project shows 0% score as it needs a building or buildings added. ' +
                'When you add a building or buildings using the Buildings editor grid, the Dwellings and/or ' +
                'Non-residential spaces editor grids will show. You can assign the dwellings and non-res spaces ' +
                'to the buildings and the project will recalculate and show the upgraded project score.'
            );
        }
    }
}